module.exports = __webpack_public_path__ + "Server-Healthy.Ssh.f2fce1e7723b781f6e00021c63b39b9a.hashedasset.svg";